import { C as t } from "../index-D7cgykJH.js";
import { student as a } from "../queries/student/index.js";
import { B as r } from "../index-BZpqZYNM.js";
const p = (n) => {
  const { isPending: e, data: o } = n ? new a.get({ studentId: n }).ToQuery() : { isPending: !1, data: null };
  return e ? null : o;
}, m = async (n) => {
  t.isNativePlatform() ? await r.open({ url: n }) : window.open(n, "_blank");
};
export {
  m as openExternalUrl,
  p as useStudent
};
//# sourceMappingURL=index.js.map
